<template>
  <b-modal id="modal-inventory-details" size="xl" hide-footer>
    <template v-slot:modal-header="{ close }">
      <h5 class="modal-title" id="exampleModalLabel">
        <a
          @click="$bvModal.hide('modal-inventory-details')"
          class="prevButton backArrow mr-2"
          data-dismiss="modal"
        >
          <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
            style="enable-background:new 0 0 512 512;"
            xml:space="preserve"
          >
            <g>
              <g>
                <path
                  d="M501.333,245.333H36.417l141.792-141.792c4.167-4.167,4.167-10.917,0-15.083c-4.167-4.167-10.917-4.167-15.083,0l-160,160
          c-4.167,4.167-4.167,10.917,0,15.083l160,160c2.083,2.083,4.813,3.125,7.542,3.125c2.729,0,5.458-1.042,7.542-3.125
          c4.167-4.167,4.167-10.917,0-15.083L36.417,266.667h464.917c5.896,0,10.667-4.771,10.667-10.667S507.229,245.333,501.333,245.333z
          "
                />
              </g>
            </g>
          </svg>
        </a> Inventory
      </h5>
      <button @click="close()" type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <div class="m-4">
      <div class="elevation-3 flatDetailsHolder">
        <b-tabs content-class pills card>
          <b-tab active>
            <template v-slot:title>
              Floor Plan
              <span class="arrow-icon">
                <svg
                  version="1.1"
                  id="Capa_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 490.656 490.656"
                  style="enable-background:new 0 0 490.656 490.656;"
                  xml:space="preserve"
                >
                  <g>
                    <g>
                      <path
                        d="M487.536,120.445c-4.16-4.16-10.923-4.16-15.083,0L245.339,347.581L18.203,120.467c-4.16-4.16-10.923-4.16-15.083,0
                                    c-4.16,4.16-4.16,10.923,0,15.083l234.667,234.667c2.091,2.069,4.821,3.115,7.552,3.115s5.461-1.045,7.531-3.136l234.667-234.667
                                    C491.696,131.368,491.696,124.605,487.536,120.445z"
                      />
                    </g>
                  </g>
                </svg>
              </span>
            </template>
            <div class="smallTab">
              <b-tabs pills card vertical >
                <b-tab title="2D" active >
                  <div class="row">
                    <div class="col-md-12">
                      <a :href="require('@/assets/images/2d-plan.jpg')" data-fancybox="gallery">
                        <img src="@/assets/images/2d-plan.jpg" class="img-fluid w-100 floorPlanImg" />
                      </a>
                    </div>
                  </div>
                </b-tab>
                <b-tab title="3D">
                  <div class="row">
                    <div class="col-md-12">
                      <a :href="require('@/assets/images/3d-image.jpg')" data-fancybox="gallery">
                        <img src="@/assets/images/3d-image.jpg" class="img-fluid w-100 floorPlanImg" />
                      </a>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </b-tab>
          <b-tab>
            <template v-slot:title>
              Flat Details
              <span class="arrow-icon">
                <svg
                  version="1.1"
                  id="Capa_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 490.656 490.656"
                  style="enable-background:new 0 0 490.656 490.656;"
                  xml:space="preserve"
                >
                  <g>
                    <g>
                      <path
                        d="M487.536,120.445c-4.16-4.16-10.923-4.16-15.083,0L245.339,347.581L18.203,120.467c-4.16-4.16-10.923-4.16-15.083,0
                                    c-4.16,4.16-4.16,10.923,0,15.083l234.667,234.667c2.091,2.069,4.821,3.115,7.552,3.115s5.461-1.045,7.531-3.136l234.667-234.667
                                    C491.696,131.368,491.696,124.605,487.536,120.445z"
                      />
                    </g>
                  </g>
                </svg>
              </span>
            </template>
            <h3 class="mb-2">Flat Details</h3>
            <div class="row">
              <div class="col-6 col-md-4 grid">
                <span class="lead-title d-block">Wing Name</span>
                <span class="lead-info d-block">{{selectedWing.name}}</span>
              </div>
              <div class="col-6 col-md-4 grid">
                <span class="lead-title d-block">Price</span>
                <span class="lead-info d-block">76 Lac</span>
              </div>
              <div class="col-6 col-md-4 grid">
                <span class="lead-title d-block">Built up Area</span>
                <span class="lead-info d-block">1140 Sqft</span>
              </div>
              <div class="col-6 col-md-4 grid">
                <span class="lead-title d-block">Parking</span>
                <span class="lead-info d-block">1(Coverd)</span>
              </div>
              <div class="col-6 col-md-4 grid">
                <span class="lead-title d-block">Facing</span>
                <span class="lead-info d-block">West</span>
              </div>
              <div class="col-6 col-md-4 grid">
                <span class="lead-title d-block">Floor</span>
                <span class="lead-info d-block">Higher</span>
              </div>
              <div class="col-6 col-md-4 grid">
                <span class="lead-title d-block">Age of Property</span>
                <span class="lead-info d-block">3 years 11 months</span>
              </div>
              <div class="col-6 col-md-4 grid">
                <span class="lead-title d-block">Loan on Property</span>
                <span class="lead-info d-block">No</span>
              </div>
              <div class="col-6 col-md-4 grid">
                <span class="lead-title d-block">Negotiable</span>
                <span class="lead-info d-block">Yes</span>
              </div>
            </div>
            <h3 class="mb-2">Society Amenities</h3>
            <div class="row amenities">
              <div class="col-6 col-xs-6 col-sm-3 col-md-2 p-1">
                <div class="grid-amenities">
                  <img src="@/assets/images/icon-swimming-pool.jpg" />
                  <p>Swimming Pool</p>
                </div>
              </div>
              <div class="col-6 col-xs-6 col-sm-3 col-md-2 p-1">
                <div class="grid-amenities">
                  <img src="@/assets/images/icon-gymnasium.jpg" />
                  <p>Gymnasium</p>
                </div>
              </div>
              <div class="col-6 col-xs-6 col-sm-3 col-md-2 p-1">
                <div class="grid-amenities">
                  <img src="@/assets/images/icon-garden.jpg" />
                  <p>Garden</p>
                </div>
              </div>
              <div class="col-6 col-xs-6 col-sm-3 col-md-2 p-1">
                <div class="grid-amenities">
                  <img src="@/assets/images/icon-child-play.jpg" />
                  <p>Child Play Area</p>
                </div>
              </div>
              <div class="col-6 col-xs-6 col-sm-3 col-md-2 p-1">
                <div class="grid-amenities">
                  <img src="@/assets/images/icon-lift.jpg" />
                  <p>Lift</p>
                </div>
              </div>
              <div class="col-6 col-xs-6 col-sm-3 col-md-2 p-1">
                <div class="grid-amenities">
                  <img src="@/assets/images/icon-power-backup.jpg" />
                  <p>Power Backup</p>
                </div>
              </div>
              <div class="col-6 col-xs-6 col-sm-3 col-md-2 p-1">
                <div class="grid-amenities">
                  <img src="@/assets/images/icon-security.jpg" />
                  <p>24x7 Security</p>
                </div>
              </div>
              <div class="col-6 col-xs-6 col-sm-3 col-md-2 p-1">
                <div class="grid-amenities">
                  <img src="@/assets/images/icon-intercomm.jpg" />
                  <p>Intercomm Facility</p>
                </div>
              </div>
              <div class="col-6 col-xs-6 col-sm-3 col-md-2 p-1">
                <div class="grid-amenities">
                  <img src="@/assets/images/icon-indoor.jpg" />
                  <p>Indoor Games</p>
                </div>
              </div>
              <div class="col-6 col-xs-6 col-sm-3 col-md-2 p-1">
                <div class="grid-amenities">
                  <img src="@/assets/images/icon-club.jpg" />
                  <p>Club house</p>
                </div>
              </div>
              <div class="col-6 col-xs-6 col-sm-3 col-md-2 p-1">
                <div class="grid-amenities">
                  <img src="@/assets/images/icon-room.jpg" />
                  <p>Multipurpose room</p>
                </div>
              </div>
              <div class="col-6 col-xs-6 col-sm-3 col-md-2 p-1">
                <div class="grid-amenities">
                  <img src="@/assets/images/icon-parking.jpg" />
                  <p>Car Parking</p>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab>
            <template v-slot:title>
              Payment details
              <span class="arrow-icon">
                <svg
                  version="1.1"
                  id="Capa_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 490.656 490.656"
                  style="enable-background:new 0 0 490.656 490.656;"
                  xml:space="preserve"
                >
                  <g>
                    <g>
                      <path
                        d="M487.536,120.445c-4.16-4.16-10.923-4.16-15.083,0L245.339,347.581L18.203,120.467c-4.16-4.16-10.923-4.16-15.083,0
                                    c-4.16,4.16-4.16,10.923,0,15.083l234.667,234.667c2.091,2.069,4.821,3.115,7.552,3.115s5.461-1.045,7.531-3.136l234.667-234.667
                                    C491.696,131.368,491.696,124.605,487.536,120.445z"
                      />
                    </g>
                  </g>
                </svg>
              </span>
            </template>
            <h3 class="mb-2">Price Breakup</h3>
            <table class="table table-bordered table-hover ctTableSize">
              <thead>
                <tr>
                  <th>Description</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>BSP (Basic Selling Price)</td>
                  <td>
                    <i class="fa fa-inr"></i> &nbsp; 64,20,060
                  </td>
                </tr>
                <tr>
                  <td>Car Park</td>
                  <td>
                    <i class="fa fa-inr"></i> &nbsp; 20,060
                  </td>
                </tr>
                <tr>
                  <td>Floor Rise</td>
                  <td>
                    <i class="fa fa-inr"></i> &nbsp; 64,20,060
                  </td>
                </tr>
                <tr>
                  <td>Electric supply, Water and Connection Charges</td>
                  <td>
                    <i class="fa fa-inr"></i> &nbsp; 64,20,060
                  </td>
                </tr>
                <tr></tr>
                <tr>
                  <td>5 year Maintenance Charges</td>
                  <td>
                    <i class="fa fa-inr"></i> &nbsp; 64,20,060
                  </td>
                </tr>
                <tr>
                  <td>VAT</td>
                  <td>
                    <i class="fa fa-inr"></i> &nbsp; 64,20,060
                  </td>
                </tr>
                <tr>
                  <td>Stamp Duty &amp; Registration Charges</td>
                  <td>
                    <i class="fa fa-inr"></i> &nbsp; 64,20,060
                  </td>
                </tr>
                <tr>
                  <td>Service Tax on BSP</td>
                  <td>
                    <i class="fa fa-inr"></i> &nbsp; 64,20,060
                  </td>
                </tr>
                <tr>
                  <td>Service Tax on Maintenance</td>
                  <td>
                    <i class="fa fa-inr"></i> &nbsp; 64,20,060
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Total</strong>
                  </td>
                  <td>
                    <i class="fa fa-inr"></i> &nbsp;
                    <strong>64,20,060</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-tab>
          <b-tab>
            <template v-slot:title>
              <span class="arrow-icon">
                <svg
                  id="Capa_1"
                  enable-background="new 0 0 512 512"
                  viewBox="0 0 512 512"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g>
                    <path
                      d="m418.474 0h-324.949v64.559h114.593c42.083 0 77.976 26.986 91.3 64.559h-205.893v64.559h205.893c-13.324 37.573-49.217 64.559-91.3 64.559h-114.593v64.559l189.203 189.205 45.65-45.651-143.552-143.552h23.292c77.943 0 143.158-55.538 158.153-129.119h52.203v-64.559h-52.203c-4.858-23.84-14.99-45.783-29.116-64.559h81.319z"
                    />
                  </g>
                </svg>
              </span>
              Book Now
            </template>
            <div class="row justify-content-center">
              <div class="col-md-7">
                <h3
                  class="text-center"
                >Booking Summary</h3>
               
                <div class="payment-grid">
                   <div class="small mb-2">Your selection</div>
                  <div class="list-group">
                    <div class="list-group-item list-group-item-action active">
                      <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-1">Flat: {{selectedFlat.name}}</h5>
                      </div>
                    </div>
                    <div class="list-group-item list-group-item-action">
                      <div class="d-flex w-100 justify-content-between">
                        <small class="text-muted d-block">Typology</small>

                        <small class="icon-tick">
                          <svg
                            version="1.1"
                            id="Capa_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            viewBox="0 0 512 512"
                            style="enable-background:new 0 0 512 512;"
                            xml:space="preserve"
                            width="14px"
                            height="14pt"
                          >
                            <g>
                              <g>
                                <path
                                  d="M437.019,74.98C388.667,26.629,324.38,0,256,0C187.619,0,123.332,26.629,74.98,74.98C26.629,123.332,0,187.62,0,256
			s26.629,132.667,74.98,181.019C123.332,485.371,187.62,512,256,512s132.667-26.629,181.019-74.98
			C485.371,388.667,512,324.38,512,256S485.371,123.333,437.019,74.98z M378.306,195.073L235.241,338.139
			c-2.929,2.929-6.768,4.393-10.606,4.393c-3.839,0-7.678-1.464-10.607-4.393l-80.334-80.333c-5.858-5.857-5.858-15.354,0-21.213
			c5.857-5.858,15.355-5.858,21.213,0l69.728,69.727l132.458-132.46c5.857-5.858,15.355-5.858,21.213,0
			C384.164,179.718,384.164,189.215,378.306,195.073z"
                                />
                              </g>
                            </g>
                          </svg>
                        </small>
                      </div>
                      <p class="mb-1 d-block">{{selectedTypology.value}}</p>
                    </div>
                    <div class="list-group-item list-group-item-action">
                      <div class="d-flex w-100 justify-content-between">
                        <small class="text-muted d-block">Floor Range</small>

                        <small class="icon-tick">
                          <svg
                            version="1.1"
                            id="Capa_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            viewBox="0 0 512 512"
                            style="enable-background:new 0 0 512 512;"
                            xml:space="preserve"
                            width="14px"
                            height="14pt"
                          >
                            <g>
                              <g>
                                <path
                                  d="M437.019,74.98C388.667,26.629,324.38,0,256,0C187.619,0,123.332,26.629,74.98,74.98C26.629,123.332,0,187.62,0,256
			s26.629,132.667,74.98,181.019C123.332,485.371,187.62,512,256,512s132.667-26.629,181.019-74.98
			C485.371,388.667,512,324.38,512,256S485.371,123.333,437.019,74.98z M378.306,195.073L235.241,338.139
			c-2.929,2.929-6.768,4.393-10.606,4.393c-3.839,0-7.678-1.464-10.607-4.393l-80.334-80.333c-5.858-5.857-5.858-15.354,0-21.213
			c5.857-5.858,15.355-5.858,21.213,0l69.728,69.727l132.458-132.46c5.857-5.858,15.355-5.858,21.213,0
			C384.164,179.718,384.164,189.215,378.306,195.073z"
                                />
                              </g>
                            </g>
                          </svg>
                        </small>
                      </div>
                      <p class="mb-1 d-block">{{selectedFloor.value}}</p>
                    </div>
               
                  <div class="list-group-item list-group-item-action">
                    <div class="d-flex w-100 justify-content-between">
                      <small class="text-muted d-block">Building</small>

                      <small class="icon-tick">
                        <svg
                          version="1.1"
                          id="Capa_1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          x="0px"
                          y="0px"
                          viewBox="0 0 512 512"
                          style="enable-background:new 0 0 512 512;"
                          xml:space="preserve"
                          width="14px"
                          height="14pt"
                        >
                          <g>
                            <g>
                              <path
                                d="M437.019,74.98C388.667,26.629,324.38,0,256,0C187.619,0,123.332,26.629,74.98,74.98C26.629,123.332,0,187.62,0,256
			s26.629,132.667,74.98,181.019C123.332,485.371,187.62,512,256,512s132.667-26.629,181.019-74.98
			C485.371,388.667,512,324.38,512,256S485.371,123.333,437.019,74.98z M378.306,195.073L235.241,338.139
			c-2.929,2.929-6.768,4.393-10.606,4.393c-3.839,0-7.678-1.464-10.607-4.393l-80.334-80.333c-5.858-5.857-5.858-15.354,0-21.213
			c5.857-5.858,15.355-5.858,21.213,0l69.728,69.727l132.458-132.46c5.857-5.858,15.355-5.858,21.213,0
			C384.164,179.718,384.164,189.215,378.306,195.073z"
                              />
                            </g>
                          </g>
                        </svg>
                      </small>
                    </div>
                    <p class="mb-1 d-block">{{selectedWing.name}}</p>
                  </div>

                  <div class="list-group-item list-group-item-action">
                    <div class="form-group">
                        <small class="text-muted d-block mb-2 ">Select Payment Plan</small>
                      <select name id class="form-control custom-select" v-model="selectedPlan">
                        <option value disabled>Select Plan</option>
                        <option v-for="plan in paymentPlans" :value="plan">{{plan}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="list-group-item list-group-item-action">
                    <div class="form-group">
                      <small class="text-muted d-block mb-2 ">Price (All incl)</small>
                      <div class="input-group mb-3">
                        <input type="text" class="form-control" placeholder="Rs 50,0000" disabled />
                        <div class="input-group-append" v-b-popover.hover.top="selectedPlan ? 'Click to Proceed!' : 'Select Plan to Book!'">
                          <button class="btn btn-success success-btn" type="button" :disabled="!selectedPlan" @click="goBook">Book Now</button>
                        </div>
                      </div>
                    </div>
                  </div>
                     </div>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { projectName, paymentPlans, santizeBookingParams, bookingUrl } from "@/assets/scripts/utility.js";
import qs from 'qs'
export default {
  props: {
    selectedWing: {
      type: Object,
      required: true,
    },
    selectedFlat: {
      type: Object,
      required: true,
    },
  },
  data(){
    return {
      selectedPlan: null
    }
  },
  methods: {
    goBook(){
      let qp = {selectedPlan: this.selectedPlan, flatName: this.selectedFlat.name, wingName: this.selectedWing.name, typologyName: this.selectedTypology.value, floorName: this.selectedFloor.value, leadNo: localStorage.getItem('crmleadNo'), cpId: localStorage.getItem('enrichr-augment-p1-cp-id')}
      let qParams = qs.stringify(santizeBookingParams(qp));
      let finalUrl = `${this.$axios.defaults.baseURL}${bookingUrl}?${qParams}`
      window.location = finalUrl
    }
  },
  computed: {
    selectedTypology() {
      return this.$store.getters.selectedTypology;
    },
    selectedFloor() {
      return this.$store.getters.selectedFloor;
    },
    projectName() {
      return projectName;
    },
    paymentPlans(){
      return paymentPlans;
    }
  },
};
</script>